import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  Skeleton,
  TableBody,
  Stack,
} from '@mui/material';

export const FileManagerContentSkeleton = () => {
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>
            <Skeleton height={26} width={50} />
          </TableCell>
          <TableCell>
            <Skeleton height={26} width={100} />
          </TableCell>
          <TableCell>
            <Skeleton height={26} width={80} />
          </TableCell>
          <TableCell />
        </TableRow>
      </TableHead>
      <TableBody>
        {[...Array(7).keys()].map((i) => (
          <TableRow key={i}>
            <TableCell padding="none">
              <Stack direction="row" spacing={1} sx={{ paddingLeft: 2 }}>
                <Skeleton
                  variant="rounded"
                  width={32}
                  height={32}
                  sx={{ marginRight: 1 }}
                />
                <Skeleton width={150} />
              </Stack>
            </TableCell>
            <TableCell>
              <Stack direction="row" spacing={1} alignItems="center">
                <Skeleton
                  variant="circular"
                  width={20}
                  height={20}
                  sx={{ marginRight: 1 }}
                />
                <Stack spacing={1}>
                  <Skeleton height={15} width={40} />
                  <Skeleton height={15} width={60} />
                </Stack>
              </Stack>
            </TableCell>
            <TableCell>
              <Skeleton variant="rounded" width={200} height={30} />
            </TableCell>
            <TableCell>
              <Skeleton variant="rounded" width={10} height={28} />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
